import React, { useCallback, useEffect, useMemo } from "react";
import { useStores } from "stores";
import { observer } from "mobx-react-lite";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { useNavigate } from "react-router-dom";
import { Flex, Typography } from "antd";
import { useWebSocketNotifications } from "utils";
import { FILTERS_KEY_ENUM } from "interfaces";
import { Switch } from "ui";
import styles from "./bids.module.css";

enum SwitchTitle {
  ONLY_MY_FUNDS = "Только мои средства",
  POSITIVE_BALANCES = "Положительные балансы",
}

const BIDS_WIDGETS = { search: true, date: true } as const;

export const BidsPage = observer(() => {
  const { bids, user, fiatCurrencyList } = useStores();
  const navigate = useNavigate();
  const { isConnected } = useWebSocketNotifications();

  const { isOperator, isCustomer, isProvider, isLPRiskManager } = user.roles;

  const switchTitle =
    isCustomer || isProvider || isLPRiskManager ? SwitchTitle.ONLY_MY_FUNDS : SwitchTitle.POSITIVE_BALANCES;
  const filtersKey = isOperator ? FILTERS_KEY_ENUM.POSITIVE_BALANCES : FILTERS_KEY_ENUM.ONLY_MY_FUNDS;

  useEffect(() => {
    if (!fiatCurrencyList?.currencyMap?.length) {
      fiatCurrencyList.onChangeDataFlow({}, { initialize: true });
    }
  }, []);

  const columns = useMemo(() => getColumns(user, bids, fiatCurrencyList), [user.roles, fiatCurrencyList?.currencyMap]);

  const handleRowClick = useCallback(
    (record: any) => ({
      onClick: () => navigate(record.id),
      className: "cursor-pointer",
    }),
    [navigate]
  );

  const handleSwitchChange = useCallback(
    (value: boolean) => {
      bids.onChangeDataFlow({
        filters: { [filtersKey]: !value ? undefined : value },
      });
    },
    [bids, filtersKey]
  );

  return (
    <Flex vertical gap="large">
      <Flex justify="space-between">
         <Typography.Title className="margin-none">Заявки </Typography.Title>

        <Flex justify="space-between" align="center" gap="small">
          <Switch
            checked={bids.filters[filtersKey]}
            onChange={handleSwitchChange}
            id={filtersKey}
            className={styles.switch}
          />
          <Typography.Text>{switchTitle}</Typography.Text>
        </Flex>
      </Flex>
      <CommonTable
        id="bids-table"
        store={bids}
        updateWithInterval={!isConnected}
        columns={columns}
        onRow={handleRowClick}
        whiteBox
        widgets={BIDS_WIDGETS}
      />
    </Flex>
  );
});
